import React from 'react';
import { TextField } from '@material-ui/core';
import ReactTextMask from 'react-text-mask';

const MaskedTextField = props => (
  <ReactTextMask
    keepCharPositions={true}
    render={(ref, _props) => (
      <TextField
        inputRef={ref}
        value={props.value}
        {..._props}
        defaultValue={undefined}
      />
    )}
    {...props}
  />
);

export default MaskedTextField;
